<template>
	<button type="button" class="ocard" :class="{ on: on }" @click="$emit('select')">
		<span class="t"><span>{{ name }}</span><span v-if="priceText" class="p">{{ priceText }} <small v-if="priceSub">{{ priceSub }}</small></span></span>
		<span v-if="desc" class="s">{{ desc }}</span>
		<span v-if="tags && tags.length" class="tags"><span v-for="(t, i) in tags" :key="i" class="yn" :class="t.tone">{{ t.label }}</span></span>
	</button>
</template>

<script>
import { money } from './money.js'

export default {
	name: 'PeOptionCard',
	props: {
		name: { type: String, default: '' },
		price: { type: [Number, String], default: null }, // cents (formatted here) or an already formatted string
		priceSub: { type: String, default: '' }, // "a year", "once", "12 months"
		desc: { type: String, default: '' },
		tags: { type: Array, default: () => [] }, // [{ label, tone }] tone: yes, no, warn, inc, blue
		on: { type: Boolean, default: false },
	},
	computed: {
		priceText() { return typeof this.price === 'number' ? money(this.price) : this.price || '' },
	},
}
</script>
